<script>
  // The gallery thumbnails are server-rendered inside the enclosing
  // [data-lightbox-scope]; one delegated listener there opens whichever one is
  // clicked at the size its data-lightbox-url points to. Bulma's modal does the
  // overlay, and .is-clipped on <html> is how Bulma stops the page behind it
  // from scrolling.
  let root = $state()
  let url = $state(null)

  function close() {
    url = null
  }

  function handleKeydown(event) {
    if (event.key === "Escape") close()
  }

  $effect(() => {
    const scope = root.closest("[data-lightbox-scope]")
    if (!scope) return

    function open(event) {
      const thumbnail = event.target.closest("[data-lightbox-url]")
      if (thumbnail) url = thumbnail.dataset.lightboxUrl
    }

    scope.addEventListener("click", open)
    return () => scope.removeEventListener("click", open)
  })

  $effect(() => {
    document.documentElement.classList.toggle("is-clipped", url !== null)
    return () => document.documentElement.classList.remove("is-clipped")
  })
</script>

<svelte:window onkeydown={handleKeydown} />

<div bind:this={root}>
  {#if url}
    <div class="modal is-active">
      <!-- svelte-ignore a11y_click_events_have_key_events -->
      <!-- svelte-ignore a11y_no_static_element_interactions -->
      <div class="modal-background" onclick={close}></div>
      <div class="modal-content">
        <figure class="image">
          <img src={url} alt="Enlarged view" />
        </figure>
      </div>
      <button class="modal-close is-large" aria-label="Close photo" onclick={close}></button>
    </div>
  {/if}
</div>

<style>
  /* The thumbnails this listens to are server-rendered outside the component,
     so the cursor that says they open something has to reach them globally. */
  :global(.photo-thumbnail) {
    cursor: pointer;
  }
</style>
